import React from "react";
import StepIn from "../../assets/img/StepIn2.jpg";
import AboutDriveImage2 from "../../assets/img/drive2.jpg";

export default function WhatDrivesUs() {
  return (
    <div className="wd-img top-img">
            <img src={StepIn} alt="Care Team" />
          </div>
  );
}

